module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/4.dcc17031.png";